import React, { useEffect, useState } from "react";
import './OnBoarding.scss';
import Icon from "../../components/Icon";
import { changeOnboardingVersion } from "../../Reducers/actions/userActions";
import { useNavigate } from "react-router-dom";
const ModalWhiteBg = ({ title, description, action, onClick }) => {


    return (<div className="modalContainer px-24 py-48">
        <p className="fs-sm2 fw-bold fg-dark ta-center">{title}</p>

        <p className="fs-sm2 fw-regular fg-crea ta-center mt-12">{description}</p>
        {action == "next" ?
            <button className="btn btn-full red-outline-btn d-flex aic jcc py-24 mt-24 fs-real"
                onClick={onClick}
            >NEXT</button>
            : <button className="btn btn-full red-btn d-flex aic jcc py-24 mt-24 fs-real"
                onClick={onClick}
            >Start hyking</button>
        }

    </div>)
}

function OnBoarding() {
    const navigate = useNavigate()
    const totalSteps = 3;
    const duration = 10000;
    const [currentStep, setCurrentStep] = useState(0);
    const [transition, setTransition] = useState(true);

    const Step1 = () => {
        return <div className="d-flex f-column jcsb aic">
            <img
                src="/OnBoarding/Onboarding_1_Creation_categories.png"
                srcSet="/OnBoarding/Onboarding_1_Creation_categories@2x.png 2x,
    /OnBoarding/Onboarding_1_Creation_categories@3x.png 3x"
                alt="Onboarding illustration"

                style={{ width: "100%", height: "50dvh" }}
            />

            {/* <div className="d-flex f-row aic jcc" >
            <Icon alias={"audio_onboarding"} color="none"  stroke={"white"}height={96} width={96} />
            <Icon alias={"camera_onboarding"} color="white" height={96} width={96} />
        </div>
        <div className="d-flex f-row jcsb aic">
            <Icon alias={"spray_onboarding"} color="white" height={96} width={96} />
            <Icon alias={"video_onboarding"} color="white" height={96} width={96} />
            <Icon alias={"logo_onboarding"} color="white" height={96} width={96} style={{
                position: "absolute",
                left: "50%",
                marginTop:"80px",
                transform: "translateX(-50%)",
            }} />
        </div>
        <div className="d-flex f-row jcsb aic">
            <Icon alias={"camera_onboarding"} color="white" height={96} width={96} />
            <Icon alias={"camera_onboarding"} color="white" height={96} width={96} />
        </div>
        <div className="d-flex f-row aic jcc ">
            <Icon alias={"camera_onboarding"} color="white" height={96} width={96} />
            <Icon alias={"camera_onboarding"} color="white" height={96} width={96} />
        </div> */}

            <ModalWhiteBg title='One place for all your creations'
                description="From music to podcasts, from zines to objects, HYK lets you publish or collect every format — digital or physical."
                action="next"
                bg='transparent'
                onClick={handleNext}


            />
        </div>
    }

    const Step2 = () => {
        return <div className="d-flex f-column jcsb aic">
            <img
                src="/OnBoarding/Onboarding_2_Hand_joining.png"
                srcSet="/OnBoarding/Onboarding_2_Hand_joining@2x.png 2x,
    /OnBoarding/Onboarding_2_Hand_joining@3x.png 3x"
                alt="Onboarding illustration"

                style={{ width: "100%", height: "50dvh" }}
            />

            <ModalWhiteBg title='Value flows both ways'
                description="Earn directly from your creations. Contribute to those you love. Every action helps creation thrive."
                action="next"
                bg='transparent'
                onClick={handleNext}
            />
        </div>
    }

    const Step3 = () => {
        return <div className="d-flex f-column jcsb aic bg-dark">
            <img
                src="/OnBoarding/Onboarding_3_Heatmap_simple.png"
                srcSet="/OnBoarding/Onboarding_3_Heatmap_simple@2x.png 2x,
    /OnBoarding/Onboarding_3_Heatmap_simple@3x.png 3x"
                alt="Onboarding illustration"

                style={{ width: "100%", height: "100dvh" }}
            />

            <ModalWhiteBg title='Explore culture differently'
                description="Navigate through culture and creation, discover new worlds, and connect with creators who inspire you."
                action="cancel"
                bg='transparent'
                onClick={handleNext}
            />
        </div>
    }

    useEffect(() => {
        if (currentStep < totalSteps) {
            if (currentStep == 0) setCurrentStep(1)
            const timeoutRef = setTimeout(() => {
                setCurrentStep((prev) => prev + 1);

            }, duration);
            return () => clearTimeout(timeoutRef);

        } else {
            //finish auto

        }

    }, [currentStep]);
    const handleIsCompleted = (step) => {
        return (currentStep > step)
    }
    const handleIsActive = (step) => {
        return (currentStep == step)
    }
    const handleNext = () => {
        if (currentStep !== 3) setCurrentStep((prev) => prev + 1)
        else {
            setTransition(false)
            changeOnboardingVersion().then(({success,message})=>{
                if (success){
                    console.log(message);
                    navigate('/explore')
                }
                
            })
        }
        setTransition(true)

    }
    return (
        <div className={currentStep == 3 ? "bg-dark" : "bg-red"} style={{
            height: '100dvh', overflow: "hidden"
        }}>
            <div className="progress-container">
                {Array.from({ length: totalSteps }).map((_, index) => {
                    return <div className="progress-bar" key={index}>
                        <div
                            className="fill"
                            style={{
                                transition: transition && handleIsActive(index + 1) ? `width ${duration}ms linear` : "none",
                                width:
                                    handleIsCompleted(index + 1)
                                        ? "100%" // already completed
                                        : handleIsActive(index + 1)
                                            ? "100%" // animate this one
                                            : "0%", // not started
                            }}
                        />
                    </div>
                })}
            </div>

            {currentStep == 1 && <Step1 />}
            {currentStep == 2 && <Step2 />}
            {currentStep == 3 && <Step3 />}
        </div>
    )
}


export default OnBoarding;